<template>
  <div>
    <div class="row mt-3 mx-0">
      <div class="col-3">
        <div class="form-group">
          <label for="numero_do_protocolo"
                 class="label">
            Número do protocolo
          </label>

          <input id="numero_do_protocolo"
                 v-model="formData.numeroProtocolo"
                 type="text"
                 class="form-control form-control-sm">
        </div>
      </div>

      <div class="col-3 d-flex align-items-end">
        <div class="form-group w-100">
          <label for="status_do_protocolo"
                 class="label">
            Status do protocolo
          </label>
          <v-select id="status_do_protocolo"
                    v-model="formData.statusProtocolo"
                    class="form-control form-control-sm"
                    :options="opcoesDeStatus" />
        </div>
      </div>

      <div class="col-2 d-flex align-items-end">
        <div class="form-group mt-3">
          <div class="row">
            <div class="col">
              <button class="btn btn-sm btn-outline-primary mt-2"
                      @click="search()">
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr style="border-color: #ccc;">

    <div class="col-3">
      <div class="">
        <span>Mostrar:</span>
        <v-select v-model="perPage"
                  :options="pageOptions"
                  class="w-50"
                  @input="search()" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EProtocoloFiltros",
    props: {
      propRegistroId: {type: Number, default: null}
    },
    data () {
      return {
        perPage: 15,
        pageOptions: [15, 30, 60, 100],
        formData: {
          numeroProtocolo: null,
          statusProtocolo: null
        },
        opcoesDeStatus: ['Pagamento pendente', 'Cancelado', 'Nota de exigência pendente', 'Em andamento', 'Aguardando manifestação de orgão externo'],
        opcoesFormatadas: {
          'Aguardando manifestação de orgão externo': 'waiting_approval_for_additional_services',
          'Pagamento pendente': 'waiting_for_payment',
          'Cancelado': 'canceled',     
          'Em andamento': 'request_received',     
          'Nota de exigência pendente': 'waiting_for_response_requirement_note'
        },
      }
    },
    methods: {
      async search () {
        try {
          const params = {
            perPage: this.perPage,
            numeroProtocolo: this.formData.numeroProtocolo,
            statusProtocolo: this.opcoesFormatadas[this.formData.statusProtocolo]
          }

          this.$emit('results', params)
        } catch (error) {
          displayMessage('error', 'Error!', error.message)
        }
      }
    }
  }
</script>

<style scoped>
</style>
